import React from 'react';
import cls from 'classnames';
import { COMPUTED_METRICS_LABELS } from '../../specs';
import './GraphLegend.scss';
function LegendCircle(_a) {
    var color = _a.color;
    return React.createElement("span", { style: { color: color } }, "\u25CF");
}
export default function GraphLegend(_a) {
    var attribute = _a.attribute, _b = _a.graphHasTitle, graphHasTitle = _b === void 0 ? false : _b;
    if (!attribute ||
        (attribute.type !== 'category' && attribute.type !== 'boolean'))
        return null;
    return (React.createElement("div", { id: "GraphLegend", className: cls(graphHasTitle && 'graph-has-title') },
        React.createElement("h6", { className: "title is-6" }, "Legend"),
        React.createElement("h6", { className: "title is-7" }, COMPUTED_METRICS_LABELS[attribute.name] || attribute.name),
        React.createElement("ul", null, attribute.top.map(function (_a) {
            var label = _a[0];
            label = '' + label;
            return (React.createElement("li", { key: label },
                React.createElement(LegendCircle, { color: attribute.palette[label] }),
                " ",
                label));
        }))));
}
